/* ==========================================================================
  listings.js
========================================================================== */
jQuery(function ($) {
    let listingFilters = {}
    $('.listing-js').find('select').on('change', function () {
      const container = $(this).closest('.listing-js')
      const listItems = $(container).find('.listing-item')
      const selectedVal = $(this).find('option:selected').val()
      const selectedName = $(this).attr('name').replace('listing-', '')

      if(selectedVal) {
        // add filter
        listingFilters[selectedName] = selectedVal
      } else {
        // remove filter if no value (selected option 'All')
        delete listingFilters[selectedName]
      }
      applyFilters(listItems)
    })

    function applyFilters(listItems) {
      let displayType = 'block'
      // check list items element type
      if(listItems[0].tagName === 'TR') {
        displayType = 'table-row'
      }

      if(!$.isEmptyObject(listingFilters)) {
        // loop list items
        $(listItems).each(function () {
          const listItem = this
          let matched = []
          // compare filtered values to list item values
          $.each(listingFilters, function(key, value) {
            // split data attribute into array incase have multiple values separated by comma
            const listItemfilters = $(listItem).data(key).toString().split(',')
            // check if 
            if($.inArray(value, listItemfilters) >= 0) {
              matched.push(true)
            } else {
              matched.push(false)
            }
          })
          
          if(matched[0] === true) {
            let show = true
            // show list item only if all matched filter values is true
            $.each(matched, function (index) {
              if(matched[index] === false) {
                show = false
              }
            })
            if(show) {
              $(listItem).css('display', displayType)
            } else {
              $(listItem).css('display', 'none')
            }
          } else {
            $(listItem).css('display', 'none')
          }
        })
      } else {
        $(listItems).each(function () {
          $(this).css('display', displayType)
        })
      }
    }
})


